import { Controller } from 'stimulus';

// Preserve the preview mode when returning from the editor.
export default class extends Controller {
  static values = { tabs: String, urls: Object };

  connect() {
    const tab = this.#tabs?.querySelector('[role="tab"][aria-selected="true"]');
    if (tab) {
      this.#point(tab.dataset.key);
    }
  }

  follow({ target, detail: { key } }) {
    if (target === this.#tabs) {
      this.#point(key);
    }
  }

  #point(key) {
    if (this.urlsValue[key]) {
      this.element.href = this.urlsValue[key];
    }
  }

  get #tabs() {
    return document.getElementById(this.tabsValue);
  }
}
